import React from 'react';

import ChildEventLink from '../../Events/elements/ChildEventLink'

export default ({talk, ...props}) =>
    <li {...props}>
        <ChildEventLink event={talk}>
            <h4>{talk.title}</h4>
            {talk.parent !== undefined &&
            <span>W ramach <b>{talk.parent.title}</b></span>
            }
        </ChildEventLink>
    </li>;



// WEBPACK FOOTER //
// ./src/modules/People/elements/TalkListItem.js